<template>
  <BreadCrumb PageTitle="Historique des tâches" />
  <HistoryCustomer :userId="userId" />
</template>

<script lang="ts">
import { defineComponent } from "vue";
import BreadCrumb from "../../components/Common/BreadCrumb.vue";
import HistoryCustomer from "../../components/Customers/HistoryCustomer.vue";
import { useRoute } from "vue-router";

export default defineComponent({
  name: "HistoryCustomerPage",
  components: {
    BreadCrumb,
    HistoryCustomer,
  },

   setup: () => {
    const route = useRoute();
    let userId = route.params.id;  // <-- get the id
    if (Array.isArray(userId)) {
      userId = userId[0] ?? "";
    }


    return { userId };
  }
});
</script>